export class UnreachableCaseError extends Error {
  constructor(val: never) {
    console.error('Unreachable case', val);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    super(`Unreachable case: ${val}`);
    // eslint-disable-next-line i18next/no-literal-string
    this.name = 'UnreachableCaseError';
  }
}
